import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'success';
  size?: 'small' | 'medium' | 'large';
}

export const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', size = 'medium', className = '', ...props }) => {
  const baseStyles = 'font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-150 ease-in-out transform hover:scale-105 active:scale-95';

  let variantStyles = '';
  switch (variant) {
    case 'primary':
      variantStyles = 'bg-yellow-500 hover:bg-yellow-600 text-gray-900 focus:ring-yellow-500';
      break;
    case 'secondary':
      variantStyles = 'bg-white hover:bg-gray-100 text-blue-600 focus:ring-blue-500';
      break;
    case 'outline':
      variantStyles = 'bg-transparent border-2 border-white text-white hover:bg-white hover:text-blue-600 focus:ring-white';
      break;
    case 'success':
      variantStyles = 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500';
      break;
    default:
      variantStyles = 'bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500';
      break;
  }

  let sizeStyles = '';
  switch (size) {
    case 'small':
      sizeStyles = 'px-4 py-2 text-sm';
      break;
    case 'large':
      sizeStyles = 'px-8 py-3 text-lg';
      break;
    case 'medium':
    default:
      sizeStyles = 'px-6 py-2.5 text-base';
      break;
  }

  return (
    <button
      className={`${baseStyles} ${variantStyles} ${sizeStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};